import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { OpsappService } from '../../services/opsapp.service';

@Component({
  selector: 'app-instrument-service',
  templateUrl: './instrument-service.component.html',
  styleUrls: ['./instrument-service.component.css']
})
export class InstrumentServiceComponent {
  services: any;
  loading: boolean = true;
  newServiceModal: boolean = false;
  instrument: any;
  
  title: string;
  summary: string;
  outOfService: boolean;
  resolveGoFMX: boolean;
  serviceCodes: any;
  selectedServiceCode: any;


  constructor(private opsappService: OpsappService, 
    private router: Router,
    private route: ActivatedRoute,
    private messageService: MessageService){
  }

  ngOnInit(){
    this.loadData();
  }

  loadData(){
    this.loading = true;
    this.opsappService.activeInstrument.pipe(first()).subscribe(data => {
      if (data == undefined || data == null)
        this.goToList();
      else
      {
        this.instrument = data;
        this.loadServiceCodes(data.details.instrumentId);
        this.opsappService.getInstrumentServices(data.details.instrumentId).then(services => {
          this.services = services;
          this.loading = false;
        });
      }
    });
  }

  goToList(){
    this.router.navigate(["instrument-list"], { relativeTo: this.route.parent });
  }

  loadServiceCodes(instrumentId: string){
    this.opsappService.getInstrumentServiceCodes(instrumentId).then(data => {
      this.serviceCodes = data;
    });
  }

  saveService(){
    var service = {
      InstrumentServiceCodeId: this.selectedServiceCode.instrumentServiceCodeId,
      InstrumentId: this.instrument.details.instrumentId,
      //Add this if we want the user to be able to change it
      TechnicianName: "",
      Title: this.title,
      Summary: this.summary,
      OutOfService: this.outOfService,
      ResolveGoFMX: this.resolveGoFMX
    };

    //change todo
    this.opsappService.createServiceRequest(service).then(data => {
      this.messageService.add({severity:'success', summary: this.instrument.friendlyInstrumentName + ' Service request created successfully!', life: 10000});
      this.newServiceModal = false;
      this.updateGoFMX(service);
    }).catch(() => {
      this.messageService.add({severity:'error', summary:'Couldn\'t create a new service request.'});
    });
  }

  updateGoFMX(service: any){
    this.opsappService.updateGoFMX(service).then(data => {
      this.messageService.add({severity:'success', summary: 'GoFMX maintenance request updated.', life: 10000});
      this.loadData();
    }).catch(() => {
      this.messageService.add({severity:'error', summary:'Couldn\'t update the related GoFMX maintenance request.'});
      this.loadData();
    });
  }

  setInstrumentIconClass(outOfService: boolean){
    if (outOfService)
      return "pi pi-ban text-red-600";
    else
      return "pi pi-check text-green-600";
  }
}
